"use client";

// Site-wide defaults for the client ImageComponent's output options (`bare`, `default_sizes`, `keep_empty_ratio`,
// `next_loader`), set once in the root layout instead of on every image. A prop on the image wins over the provider.
// Without a provider nothing changes.
// Added for mahya-tajhiz: its fork components/common/Image-component.js kept core 14's output on all its images.

import { createContext, useContext } from "react";

const ImageOptionsContext = createContext(undefined);

export const ImageOptionsProvider = ({ value, children }) => (
	<ImageOptionsContext.Provider value={value || undefined}>{children}</ImageOptionsContext.Provider>
);

export const useImageOptions = () => useContext(ImageOptionsContext);
